export default {
    congratulations: 'សូមអបអរសាទរ',
    you_get_a_free_spin: 'អ្នកទទួលបានការបង្វិលដោយឥតគិតថ្លៃ',
    spin_now: 'បង្វិលឥឡូវនេះ',
};
